/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1061
 */

module.exports = {
  wrapper: "DevTools_wrapper__1OwK-",
  dataWatchContainer: "DevTools_dataWatchContainer__P8VJb",
  consolePanelContainer: "DevTools_consolePanelContainer__3BONE",
  miniWrapper: "DevTools_miniWrapper__1n17T",
  foldContainer: "DevTools_foldContainer__3vmUI",
  expanded: "DevTools_expanded__TRAoa",
  iconContainer: "DevTools_iconContainer__3i-Fb",
  toolContent: "DevTools_toolContent__2_AQC"
}
